module.exports = __webpack_public_path__ + "static/media/U1-T2-1-3.5546c1bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-3.svg
// module id = 527
// module chunks = 0